/** Relative "Verified …" copy for employer verification timestamps (past-focused rail). */
function formatVerifiedRelative(iso: string): string {
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return '';
  const now = Date.now();
  const diffSec = Math.round((t - now) / 1000);
  const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
  const ad = Math.abs(diffSec);
  if (ad < 45) return `Verified ${rtf.format(diffSec, 'second')}`;
  const diffMin = Math.round(diffSec / 60);
  if (Math.abs(diffMin) < 60) return `Verified ${rtf.format(diffMin, 'minute')}`;
  const diffHr = Math.round(diffMin / 60);
  if (Math.abs(diffHr) < 48) return `Verified ${rtf.format(diffHr, 'hour')}`;
  const diffDay = Math.round(diffHr / 24);
  if (Math.abs(diffDay) < 14) return `Verified ${rtf.format(diffDay, 'day')}`;
  const diffWeek = Math.round(diffDay / 7);
  if (Math.abs(diffWeek) < 8) return `Verified ${rtf.format(diffWeek, 'week')}`;
  const diffMonth = Math.round(diffDay / 30);
  return `Verified ${rtf.format(diffMonth, 'month')}`;
}

/** Compact past-relative labels (e.g. "Verified 3h ago"); falls back to calendar-style relative for future/edge. */
export function formatVerifiedRelativeRail(iso: string): string {
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return '';
  const now = Date.now();
  const secAgo = Math.round((now - t) / 1000);
  if (secAgo < 0) return formatVerifiedRelative(iso);
  if (secAgo < 50) return 'Verified just now';
  if (secAgo < 3600) {
    const m = Math.max(1, Math.floor(secAgo / 60));
    return `Verified ${m}m ago`;
  }
  if (secAgo < 48 * 3600) {
    const h = Math.max(1, Math.floor(secAgo / 3600));
    return `Verified ${h}h ago`;
  }
  const d = Math.floor(secAgo / (24 * 3600));
  if (d < 14) return `Verified ${d}d ago`;
  return formatVerifiedRelative(iso);
}
